// Maps a free-form courier name + tracking number to the courier's public
// tracking URL. Returns { url, label } or null when we don't know the courier.
//
// Covers: Delhivery, Bluedart, DTDC, Ecom Express, Shiprocket, XpressBees,
// DHL, FedEx, India Post, Aramex, UPS, Professional, Gati, Amazon, Ekart.

const COURIER_MAP = [
  { match: /delhivery/i,                 label: "Delhivery",      url: (t) => `https://www.delhivery.com/track-v2/package/${encodeURIComponent(t)}` },
  { match: /blue\s*dart|bluedart/i,      label: "Blue Dart",      url: (t) => `https://www.bluedart.com/web/guest/trackdartresult?trackFor=0&trackNo=${encodeURIComponent(t)}` },
  { match: /dtdc/i,                      label: "DTDC",           url: (t) => `https://www.dtdc.in/tracking/tracking_results.asp?Ttype=awb_no&strCnno=${encodeURIComponent(t)}` },
  { match: /ecom\s*express|ecomexpress/i,label: "Ecom Express",   url: (t) => `https://www.ecomexpress.in/tracking/?awb_field=${encodeURIComponent(t)}` },
  { match: /xpressbees|xpress\s*bees/i,  label: "Xpressbees",     url: (t) => `https://www.xpressbees.com/shipment/tracking?awbNo=${encodeURIComponent(t)}` },
  { match: /shiprocket/i,                label: "Shiprocket",     url: (t) => `https://shiprocket.co/tracking/${encodeURIComponent(t)}` },
  { match: /\bdhl\b/i,                   label: "DHL",            url: (t) => `https://www.dhl.com/in-en/home/tracking/tracking-express.html?submit=1&tracking-id=${encodeURIComponent(t)}` },
  { match: /fedex/i,                     label: "FedEx",          url: (t) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(t)}` },
  { match: /india\s*post|speed\s*post|indiapost/i, label: "India Post", url: (t) => `https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx?searchBy=${encodeURIComponent(t)}` },
  { match: /aramex/i,                    label: "Aramex",         url: (t) => `https://www.aramex.com/in/en/track/results?mode=0&ShipmentNumber=${encodeURIComponent(t)}` },
  { match: /\bups\b/i,                   label: "UPS",            url: (t) => `https://www.ups.com/track?loc=en_IN&tracknum=${encodeURIComponent(t)}` },
  { match: /professional/i,              label: "Professional",   url: (t) => `https://www.tpcindia.com/Tracking.aspx?ConsignmentNo=${encodeURIComponent(t)}` },
  { match: /\bgati\b/i,                  label: "Gati",           url: (t) => `https://www.gati.com/shipment-tracking/?dkt_no=${encodeURIComponent(t)}` },
  { match: /amazon|shipping\s*services/i,label: "Amazon Shipping",url: (t) => `https://track.amazon.in/tracking/${encodeURIComponent(t)}` },
  { match: /ekart/i,                     label: "Ekart",          url: (t) => `https://ekartlogistics.com/shipmenttrack/${encodeURIComponent(t)}` },
];

/**
 * @param {string} courier  free-form courier name e.g. "Bluedart", "DTDC Express"
 * @param {string} trackingNumber
 * @returns {{ url: string, label: string } | null}
 */
export const getCourierTrackingLink = (courier, trackingNumber) => {
  if (!trackingNumber) return null;
  const c = (courier || "").toString().trim();
  if (c) {
    const hit = COURIER_MAP.find((m) => m.match.test(c));
    if (hit) return { url: hit.url(trackingNumber), label: hit.label };
  }
  // fallback: try Google search for tracking number — always safe
  return {
    url: `https://www.google.com/search?q=${encodeURIComponent(`${c || "courier"} tracking ${trackingNumber}`)}`,
    label: c ? `Track on ${c}` : "Search tracking",
  };
};

export const KNOWN_COURIERS = COURIER_MAP.map((m) => m.label);
